export type UseNetworkCostDisplayStateArgs = {
  isLoading: boolean;
  isCapabilitiesLoading: boolean;
  hasNetworkAgent: boolean;
  isDataProcessing: boolean;
  dataLength: number;
};

export type NetworkCostDisplayState = {
  hasNoData: boolean;
  showActionRequired: boolean;
  showProcessing: boolean;
  showNoData: boolean;
};

export const useNetworkCostDisplayState = (
  useNetworkCostDisplayStateArgs: UseNetworkCostDisplayStateArgs
): NetworkCostDisplayState => {
  const {
    isLoading,
    isCapabilitiesLoading,
    hasNetworkAgent,
    isDataProcessing,
    dataLength,
  } = useNetworkCostDisplayStateArgs;

  const hasNoData = !isLoading && !isCapabilitiesLoading && !dataLength;
  const showActionRequired = !isCapabilitiesLoading && !hasNetworkAgent;
  const showProcessing =
    !isCapabilitiesLoading && isDataProcessing && hasNetworkAgent;
  const showNoData = (hasNoData || showProcessing) && hasNetworkAgent;

  return { hasNoData, showActionRequired, showProcessing, showNoData };
};
